module.exports = __webpack_public_path__ + "img/06.1b664371.jpg";